import React from 'react';
import { useHistory } from 'react-router-dom';
import { OrganizationForm } from 'src/dashboard/forms/organization-form';
import { Helmet } from 'react-helmet';
import { Organization } from 'src/common/interfaces/organization.interface';

import { useCurrentOrganization } from 'src/store/organization';

export const PageOnboardingOrganization = () => {
  const history = useHistory();

  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);
  const setCurrentOrganization = useCurrentOrganization((state) => state.setCurrentOrganization);

  const onSubmit = (organization: Organization) => {
    setCurrentOrganization(organization);
    history.push('./brand');
  };

  return (
    <>
      <Helmet>
        <title>Journey | Account Setup</title>
      </Helmet>
      <div className='flex flex-col items-center w-full max-w-[500px] mx-auto px-6 py-12'>
        <div className='text-4xl font-bold text-center mb-12 text-bedrock-black'>Account Setup</div>
        <div className='w-full'>
          <OrganizationForm
            formClassName='w-full'
            currentOrganization={currentOrganization}
            submitLabel='Next'
            onSubmit={onSubmit}
            allowSubmitWhenNotDirty
            stretchSaveButton
          />
          <div className='text-bedrock-p-small text-center mt-4'>
            *Reach out to support@journey.io if you're interested in a custom domain
          </div>
        </div>
      </div>
    </>
  );
};
